// Import all icons
import FlameIcon from '@/assets/icons/Flame.png';
import BodyIcon from '@/assets/icons/Body.png';
import HearingIcon from '@/assets/icons/Hearing.png';
import HeartIcon from '@/assets/icons/Heart.png';
import MindfulnessIcon from '@/assets/icons/Mindfulness.png';
import MobilityIcon from '@/assets/icons/Mobility.png';
import NutritionIcon from '@/assets/icons/Nutrition.png';
import RespiratoryIcon from '@/assets/icons/Respiratory.png';
import SleepIcon from '@/assets/icons/Sleep.png';
import SymptomsIcon from '@/assets/icons/Symtoms.png';
import VitalsIcon from '@/assets/icons/Vitals.png';
import OtherIcon from '@/assets/icons/Other.png';

/** Apple Categories and icons */
export const CategoriesList = [
  { id:"activity", name: "Activity", icon: FlameIcon },
  { id:"body", name: "Body Measurements", icon: BodyIcon },
  { id:"hearing", name: "Hearing", icon: HearingIcon },
  { id:"heart", name: "Heart", icon: HeartIcon },
  { id:"mindfulness", name: "Mindfulness", icon: MindfulnessIcon },
  { id:"mobility", name: "Mobility", icon: MobilityIcon },
  { id:"nutrition", name: "Nutrition", icon: NutritionIcon },
  { id:"respiratory", name: "Respiratory", icon: RespiratoryIcon },
  { id:"sleep", name: "Sleep", icon: SleepIcon },
  { id:"symtoms", name: "Symptoms", icon: SymptomsIcon },
  { id:"vitals", name: "Vitals", icon: VitalsIcon },
  { id:"other", name: "Other Data", icon: OtherIcon },
  { id:"survey", name: "Surveys", icon: OtherIcon, customAction:"surveyUser" },
];

/** Apple Categories that need average instead of summation */
export const dataTypeToCalculateAverage = [
  "HKQuantityTypeIdentifierRestingHeartRate",
  "HKQuantityTypeIdentifierHeartRate",
  "HKQuantityTypeIdentifierHeartRateVariabilitySDNN",
  "HKQuantityTypeIdentifierBodyFatPercentage",
  "HKQuantityTypeIdentifierEnvironmentalAudioExposure",
  "HKQuantityTypeIdentifierOxygenSaturation",
  "HKQuantityTypeIdentifierBloodAlcoholContent",
  "HKQuantityTypeIdentifierRespiratoryRate",
  "HKQuantityTypeIdentifierWalkingDoubleSupportPercentage"
]

export const dataTypeToRounded = [
  "HKQuantityTypeIdentifierRestingHeartRate",
  "HKQuantityTypeIdentifierHeartRate",
  "HKQuantityTypeIdentifierHeartRateVariabilitySDNN",
  "HKQuantityTypeIdentifierRespiratoryRate"
]

export const logosByCategory = {
  'Activity': FlameIcon,
  'Body': BodyIcon,
  "Hearing": HearingIcon,
  "Heart": HeartIcon,
  "Mindfulness": MindfulnessIcon,
  "Mobility": MobilityIcon,
  "Nutrition": NutritionIcon,
  "Respiratory": RespiratoryIcon,
  "Sleep": SleepIcon,
  "Symptoms": SymptomsIcon,
  "Vitals": VitalsIcon,
  "Other Data": OtherIcon,
  "Surveys": OtherIcon,
}


export const categoriesOfSubcategories = {
  'HKQuantityTypeIdentifierDistanceWalkingRunning': 'Activity',
  'HKQuantityTypeIdentifierActiveEnergyBurned':'Activity',
  'HKQuantityTypeIdentifierAppleStandTime':'Activity',
  'HKQuantityTypeIdentifierAppleStandHour':'Activity',
  'HKQuantityTypeIdentifierAppleExerciseTime':'Activity',
  'HKQuantityTypeIdentifierFlightsClimbed':'Activity',
  'HKQuantityTypeIdentifierPushCount':'Activity',
  'HKQuantityTypeIdentifierDistanceWheelchair':'Activity',
  'HKQuantityTypeIdentifierDistanceCycling':'Activity',
  'HKQuantityTypeIdentifierDistanceDownhillSnowSports':'Activity',
  'HKQuantityTypeIdentifierBasalEnergyBurned':'Activity',
  'HKQuantityTypeIdentifierSwimmingStrokeCount':'Activity',
  'HKQuantityTypeIdentifierDistanceSwimming':'Activity',
  'HKQuantityTypeIdentifierStepCount':'Activity',


  "HKQuantityTypeIdentifierBasalBodyTemperature":"Body",
  "HKQuantityTypeIdentifierBodyFatPercentage":"Body",
  "HKQuantityTypeIdentifierLeanBodyMass":"Body",
  "HKQuantityTypeIdentifierBodyTemperature":"Body",
  "HKQuantityTypeIdentifierBodyMass":"Body",
  "HKQuantityTypeIdentifierBodyMassIndex":"Body",
  "HKQuantityTypeIdentifierElectrodermalActivity":"Body",
  "HKQuantityTypeIdentifierHeight":"Body",
  "HKQuantityTypeIdentifierWaistCircumference":"Body",

  "HKSampleTypeIdentifierAudiogram":"Hearing",
  "HKQuantityTypeIdentifierEnvironmentalAudioExposure":"Hearing",

  "HKQuantityTypeIdentifierBloodPressureSystolic":"Heart",
  "HKQuantityTypeIdentifierBloodPressureDiastolic":"Heart",
  "HKQuantityTypeIdentifierHeartRateVariabilitySDNN":"Heart",
  "HKQuantityTypeIdentifierPeripheralPerfusionIndex":"Heart",
  "HKQuantityTypeIdentifierRestingHeartRate":"Heart",
  "HKQuantityTypeIdentifierHeartRate":"Heart",

  "HKCategoryTypeIdentifierMindfulSession":"Mindfulness",

  "HKQuantityTypeIdentifierWalkingDoubleSupportPercentage":"Mobility",
  "HKQuantityTypeIdentifierStairDescentSpeed":"Mobility",
  "HKQuantityTypeIdentifierStairAscentSpeed":"Mobility",
  "HKQuantityTypeIdentifierWalkingSpeed":"Mobility",
  "HKQuantityTypeIdentifierSixMinuteWalkTestDistance":"Mobility",
  "HKQuantityTypeIdentifierwalkingAsymmetryPercentage":"Mobility",

  "HKQuantityTypeIdentifierDietaryPantothenicAcid":"Nutrition",
  "HKQuantityTypeIdentifierDietarySelenium":"Nutrition",
  "HKQuantityTypeIdentifierDietarySodium":"Nutrition",
  "HKQuantityTypeIdentifierDietaryThiamin":"Nutrition",
  "HKQuantityTypeIdentifierDietaryVitaminA":"Nutrition",
  "HKQuantityTypeIdentifierDietaryEnergyConsumed":"Nutrition",
  "HKQuantityTypeIdentifierDietaryIron":"Nutrition",
  "HKQuantityTypeIdentifierDietaryMagnesium":"Nutrition",
  "HKQuantityTypeIdentifierDietaryManganese":"Nutrition",
  "HKQuantityTypeIdentifierDietaryMolybdenum":"Nutrition",
  "HKQuantityTypeIdentifierDietaryNiacin":"Nutrition",
  "HKQuantityTypeIdentifierDietaryPotassium":"Nutrition",
  "HKQuantityTypeIdentifierDietaryProtein":"Nutrition",
  "HKQuantityTypeIdentifierDietaryPhosphorus":"Nutrition",
  "HKQuantityTypeIdentifierDietaryRiboflavin":"Nutrition",
  "HKQuantityTypeIdentifierDietaryFatTotal":"Nutrition",
  "HKQuantityTypeIdentifierDietaryCarbohydrates":"Nutrition",
  "HKQuantityTypeIdentifierDietaryChloride":"Nutrition",
  "HKQuantityTypeIdentifierDietaryChromium":"Nutrition",
  "HKQuantityTypeIdentifierDietaryCholesterol":"Nutrition",
  "HKQuantityTypeIdentifierDietaryCopper":"Nutrition",
  "HKQuantityTypeIdentifierDietaryFiber":"Nutrition",
  "HKQuantityTypeIdentifierDietaryFatSaturated":"Nutrition",
  "HKQuantityTypeIdentifierDietaryFatMonounsaturated":"Nutrition",
  "HKQuantityTypeIdentifierDietaryFatPolyunsaturated":"Nutrition",
  "HKQuantityTypeIdentifierDietaryBiotin":"Nutrition",
  "HKQuantityTypeIdentifierDietaryCaffeine":"Nutrition",
  "HKQuantityTypeIdentifierDietaryCalcium":"Nutrition",
  "HKQuantityTypeIdentifierDietarySugar":"Nutrition",
  "HKQuantityTypeIdentifierDietaryFolate":"Nutrition",
  "HKQuantityTypeIdentifierDietaryWater":"Nutrition",
  "HKQuantityTypeIdentifierDietaryIodine":"Nutrition",
  "HKQuantityTypeIdentifierDietaryVitaminB6":"Nutrition",
  "HKQuantityTypeIdentifierDietaryVitaminB12":"Nutrition",
  "HKQuantityTypeIdentifierDietaryVitaminC":"Nutrition",
  "HKQuantityTypeIdentifierDietaryVitaminD":"Nutrition",
  "HKQuantityTypeIdentifierDietaryVitaminE":"Nutrition",
  "HKQuantityTypeIdentifierDietaryVitaminK":"Nutrition",
  "HKQuantityTypeIdentifierDietaryZinc":"Nutrition",

  "HKQuantityTypeIdentifierBloodAlcoholContent":"Other Data",
  "HKQuantityTypeIdentifierInhalerUsage":"Other Data",
  "HKQuantityTypeIdentifierInsulinDelivery":"Other Data",
  "HKQuantityTypeIdentifierNumberOfTimesFallen":"Other Data",
  "HKQuantityTypeIdentifierSexualActivity":"Other Data",
  "HKQuantityTypeIdentifierUvExposure":"Other Data",
  "HKQuantityTypeIdentifierBloodGlucose":"Other Data",
  "HKCategoryTypeIdentifierToothbrushingEvent":"Other Data",
  "HKCategoryTypeIdentifierSexualActivity":"Other Data",
  "HKCategoryTypeIdentifierHandwashingEvent":"Other Data",

  "HKQuantityTypeIdentifierOxygenSaturation":"Respiratory",
  "HKQuantityTypeIdentifierInhalerUsage":"Respiratory",
  "HKQuantityTypeIdentifierRespiratoryRate":"Respiratory",
  "HKQuantityTypeIdentifierForcedExpiratoryVolume1":"Respiratory",
  "HKQuantityTypeIdentifierForcedVitalCapacity":"Respiratory",
  "HKQuantityTypeIdentifierSixMinuteWalkTestDistance":"Respiratory",
  "HKQuantityTypeIdentifierPeakExpiratoryFlowRate":"Respiratory",

  "HKCategoryTypeIdentifierSleepAnalysis":"Sleep",

  "HKCategoryTypeIdentifierAppetiteChanges":"Symptoms",
  "HKCategoryTypeIdentifierAbdominalCramps":"Symptoms",
  "HKCategoryTypeIdentifierBloating":"Symptoms",
  "HKCategoryTypeIdentifierConstipation":"Symptoms",
  "HKCategoryTypeIdentifierDiarrhea":"Symptoms",
  "HKCategoryTypeIdentifierHeartburn":"Symptoms",
  "HKCategoryTypeIdentifierNausea":"Symptoms",
  "HKCategoryTypeIdentifierVomiting":"Symptoms",
  "HKCategoryTypeIdentifierChills":"Symptoms",
  "HKCategoryTypeIdentifierDizziness":"Symptoms",
  "HKCategoryTypeIdentifierFainting":"Symptoms",
  "HKCategoryTypeIdentifierFatigue":"Symptoms",
  "HKCategoryTypeIdentifierFever":"Symptoms",
  "HKCategoryTypeIdentifierGeneralizedBodyAche":"Symptoms",
  "HKCategoryTypeIdentifierHotFlashes":"Symptoms",
  "HKCategoryTypeIdentifierChestTightnessOrPain":"Symptoms",
  "HKCategoryTypeIdentifierCoughing":"Symptoms",
  "HKCategoryTypeIdentifierRapidPoundingOrFlutteringHeartbeat":"Symptoms",
  "HKCategoryTypeIdentifierShortnessOfBreath":"Symptoms",
  "HKCategoryTypeIdentifierSkippedHeartbeat":"Symptoms",
  "HKCategoryTypeIdentifierWheezing":"Symptoms",
  "HKCategoryTypeIdentifierLowerBackPain":"Symptoms",
  "HKCategoryTypeIdentifierHeadache":"Symptoms",
  "HKCategoryTypeIdentifierMemoryLapse":"Symptoms",
  "HKCategoryTypeIdentifierMoodChanges":"Symptoms",
  "HKCategoryTypeIdentifierLossOfSmell":"Symptoms",
  "HKCategoryTypeIdentifierLossOfTaste":"Symptoms",
  "HKCategoryTypeIdentifierRunnyNose":"Symptoms",
  "HKCategoryTypeIdentifierSoreThroat":"Symptoms",
  "HKCategoryTypeIdentifierSinusCongestion":"Symptoms",
  "HKCategoryTypeIdentifierBreastPain":"Symptoms",
  "HKCategoryTypeIdentifierPelvicPain":"Symptoms",
  "HKCategoryTypeIdentifierVaginalDryness":"Symptoms",
  "HKCategoryTypeIdentifierAcne":"Symptoms",
  "HKCategoryTypeIdentifierDrySkin":"Symptoms",
  "HKCategoryTypeIdentifierHairLoss":"Symptoms",
  "HKCategoryTypeIdentifierNightSweats":"Symptoms",
  "HKCategoryTypeIdentifierSleepChanges":"Symptoms",
  "HKCategoryTypeIdentifierBladderIncontinence":"Symptoms",

  "HKQuantityTypeIdentifierOxygenSaturation":"Vitals",
  "HKQuantityTypeIdentifierBasalBodyTemperature":"Vitals",
  "HKQuantityTypeIdentifierBloodPressureSystolic":"Vitals",
  "HKQuantityTypeIdentifierBloodPressureDiastolic":"Vitals",
  "HKQuantityTypeIdentifierBloodGlucose":"Vitals",
  "HKQuantityTypeIdentifierMenstrualFlow":"Vitals",
}